import React from "react";
import { useTheme } from "../../theme/ThemeContext";
import { useAccountMetrics } from "../../hooks/usePriceSubscription";
import { useSelector } from "react-redux";

const M = ({ label, value, color, fmt, theme }) => (
  <div
    style={{ display: "flex", flexDirection: "column", gap: 1, minWidth: 0 }}
  >
    <span
      style={{
        fontSize: 9,
        color: theme.textM,
        textTransform: "uppercase",
        letterSpacing: "0.06em",
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
    <span
      style={{
        fontSize: 11,
        fontWeight: 700,
        color: color || theme.text,
        fontFamily: theme.mono,
        whiteSpace: "nowrap",
        fontVariantNumeric: "tabular-nums",
      }}
    >
      {fmt ? fmt(value) : typeof value === "number" ? value.toFixed(2) : value}
    </span>
  </div>
);
const D = ({ theme }) => (
  <div
    style={{ width: 1, height: 24, background: theme.border, flexShrink: 0 }}
  />
);

const AccountBar = ({ isMobile }) => {
  const theme = useTheme();
  const m = useAccountMetrics();
  const acct = useSelector((s) => s.platform.account);
  const socketStatus = useSelector((s) => s.platform.socketStatus);
  const connectionColor =
    socketStatus === "connected"
      ? theme.pos
      : socketStatus === "reconnecting" || socketStatus === "connecting"
        ? theme.orange
        : theme.neg;
  const connectionLabel =
    socketStatus === "connected"
      ? "LIVE"
      : socketStatus === "reconnecting"
        ? "RECONNECTING"
        : socketStatus === "connecting"
          ? "CONNECTING"
          : "OFFLINE";

  const profitColor =
    m.totalProfit > 0 ? theme.pos : m.totalProfit < 0 ? theme.neg : theme.text;
  return (
    <div
      style={{
        background: theme.card,
        borderBottom: `1px solid ${theme.border}`,
        padding: "5px 16px",
        display: "flex",
        alignItems: "center",
        gap: 16,
        overflowX: "auto",
        scrollbarWidth: "none",
        flexShrink: 0,
      }}
    >
      {isMobile ? null : (
        <>
          <M
            label="Login"
            value={acct.login}
            fmt={(v) => String(v)}
            theme={theme}
          />
          <D theme={theme} />
        </>
      )}
      <M label="Balance" value={m.balance} theme={theme} />
      <M label="Credit" value={m.credit} theme={theme} />
      <D theme={theme} />
      <M label="Equity" value={m.equity} color={profitColor} theme={theme} />
      <M label="P&L" value={m.totalProfit} color={profitColor} theme={theme} />
      <D theme={theme} />
      <M label="Margin" value={m.totalMargin} theme={theme} />
      <M label="Free Margin" value={m.freeMargin} theme={theme} />
      {m.marginLevel > 0 && (
        <M
          label="Margin Level"
          value={`${m.marginLevel.toFixed(0)}%`}
          color={
            m.marginLevel < 150
              ? theme.neg
              : m.marginLevel < 300
                ? theme.orange
                : theme.pos
          }
          theme={theme}
        />
      )}
      {isMobile ? null : (
        <div
          style={{
            marginLeft: "auto",
            display: "flex",
            alignItems: "center",
            gap: 5,
            flexShrink: 0,
          }}
        >
          <div
            style={{
              width: 7,
              height: 7,
              borderRadius: "50%",
              background: connectionColor,
              boxShadow: `0 0 8px ${connectionColor}`,
            }}
          />
          <span
            style={{
              fontSize: 9,
              color: connectionColor,
              fontWeight: 700,
              letterSpacing: "0.05em",
            }}
          >
            {connectionLabel}
          </span>
        </div>
      )}
    </div>
  );
};
export default AccountBar;
